import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import {
  NakedButton,
  PopoverMenu,
  PopoverMenuItem,
  Text,
  usePopoverMenu,
  useTooltip,
  styles,
} from '@frontend/design-system';
import { ThreadAttachedAsset } from '../../types';
import {
  menuItemContainer,
  tooltipTrigger,
  button,
  buttonOpen,
  overflowText,
  popoverMenu,
  menuItemIcon,
  menuItemText,
} from './attached-assets-overflow-menu.styles';

type AttachedAssetsOverflowMenuProps = {
  hiddenAssets: ThreadAttachedAsset[];
  overflowCount: number;
};

export const AttachedAssetsOverflowMenu = ({ hiddenAssets, overflowCount }: AttachedAssetsOverflowMenuProps) => {
  const { t } = useTranslation('integrated-messaging');
  const { getTriggerProps, getMenuProps, isOpen, open, close } = usePopoverMenu({
    placement: 'bottom-end',
  });
  const { ref: menuTriggerRef, ...menuTriggerProps } = getTriggerProps();
  const { Tooltip, tooltipProps, triggerProps } = useTooltip({ placement: 'top' });

  return (
    <li className={menuItemContainer}>
      <span {...triggerProps} className={tooltipTrigger}>
        <NakedButton
          type='button'
          ref={menuTriggerRef}
          {...menuTriggerProps}
          onClick={() => {
            if (isOpen) {
              close();
            } else {
              open();
            }
          }}
          className={`${button} ${isOpen ? buttonOpen : ''}`}
        >
          <Text as='span' size='small' color='primary' className={overflowText}>
            {`+${overflowCount}`}
          </Text>
        </NakedButton>
        <Tooltip {...tooltipProps}>{t('View More')}</Tooltip>
      </span>
      <PopoverMenu {...getMenuProps()} className={popoverMenu}>
        {hiddenAssets.map((asset) => {
          return (
            <PopoverMenuItem key={asset.id}>
              <Icon name={asset.iconName ?? 'document-small'} size={16} color='light' className={menuItemIcon} />

              <Text as='span' size='large' css={[styles.truncate]} className={menuItemText}>
                {asset.name}
              </Text>
            </PopoverMenuItem>
          );
        })}
      </PopoverMenu>
    </li>
  );
};
